// extracted by mini-css-extract-plugin
module.exports = {"emptyTextRoot":"index-emptyTextRoot-QMGi-"};